"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Library.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _forms = require('shared/services/forms');

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _user = require('shared/selectors/user');
var _peers = require('shared/selectors/peers');
var _hooks = require('web/services/hooks');
var _Form = require('web/components/Form');

var _common = require('./common');
var _icons = require('./icons');



 const statusOf = (f) =>
  _forms.isSetTime.call(void 0, f.PublishedAt) ? 'published' : f.PublishRequestedTo ? 'waiting' : 'draft'; exports.statusOf = statusOf

const CHIPS = {
  published: { label: 'Published', Icon: _icons.CheckIcon },
  waiting: { label: 'Waiting for an admin', Icon: _icons.ClockIcon },
  draft: { label: 'Draft', Icon: _icons.PencilIcon },
}

const useName = (userKey) => _hooks.useAppSelector.call(void 0, state => {
  const user = userKey ? _peers.selectUserV2ByKey.call(void 0, state, userKey ) : undefined
  return (user && [user.FirstName, user.LastName].filter(Boolean).join(' ')) || 'Someone'
})








const FormCard = ({ form, firstPage, isMine, onOpen }) => {
  const status = exports.statusOf.call(void 0, form)
  const { label, Icon } = CHIPS[status]
  const creator = useName(form.CreatedBy)
  const admin = useName(form.PublishRequestedTo)
  const waitsForMe = status === 'waiting' && isMine
  const open = () => onOpen(form.FormKey)
  const footer = status === 'published'
    ? `Published ${_common.dayText.call(void 0, form.PublishedAt)}`
    : status === 'waiting'
      ? `Asked ${admin} · ${_common.dayText.call(void 0, form.PublishRequestedAt)}`
      : `Added ${_common.dayText.call(void 0, form.CreatedAt)} by ${creator}`
  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'forms-card', waitsForMe && 'forms-card--waiting-me'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
      , _react2.default.createElement('button', { type: "button", className: "forms-card--open", onClick: open, 'aria-label': `${form.Name}, ${label}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        , _react2.default.createElement('span', { className: "forms-card--thumb", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
          ,  firstPage && _react2.default.createElement('img', { src: firstPage.URL, alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}} ) 
          , _react2.default.createElement('span', { className: `forms-chip forms-chip--${status}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}, _react2.default.createElement(Icon, { size: 12, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}} ),  label )
        )
        , _react2.default.createElement('span', { className: "forms-card--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
          , _react2.default.createElement('span', { className: "forms-card--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}},  form.Name )
          , _react2.default.createElement('span', { className: "forms-card--meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
            , _react2.default.createElement('span', { className: "forms-card--kind", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}},  form.IsLog ? 'Log' : 'Form' )
            ,  _common.pluralize.call(void 0, form.PageCount, 'page', 'pages') , " · "  ,  _common.pluralize.call(void 0, form.FieldCount, 'field', 'fields') 
          )
          ,  !waitsForMe && _react2.default.createElement('span', { className: "forms-card--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}},  footer ) 
        )
      )
      ,  waitsForMe && (
        _react2.default.createElement('div', { className: "forms-card--review", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
          , _react2.default.createElement(_Form.Button, { onClick: open, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, "Review and publish"  )
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "Waiting since "  ,  _common.dayText.call(void 0, form.PublishRequestedAt) )
        )
      )
    )
  )
}

/* Screen 13: the forms waiting on you to publish them. The server doesn't
 * store who asked (the request is a chat message), so it names no one. */
const AdminBanner = ({ count }) => (
  _react2.default.createElement('div', { className: "forms-banner", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
    , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 80}},  count === 1 ? '1 form is waiting for you.' : `${count} forms are waiting for you.` )
  )
)






/* Screen 1: the first visit. */
 const LibraryEmpty = ({ onUpload, onScan }) => (
  _react2.default.createElement('div', { className: "forms-empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
    , _react2.default.createElement('div', { className: "forms-empty--art", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
      , _react2.default.createElement('div', { className: "forms-empty--page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} ), _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} ), _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} ), _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} ), _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} ), _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} )
      )
    )
    , _react2.default.createElement('div', { className: "forms-empty--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
      , _react2.default.createElement('h2', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}, "Your paper forms, signed from a phone"      )
      , _react2.default.createElement('ol', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
        , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}, "Upload a PDF or a photo of a paper form."         )
        , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}, "Place the fields, or let Auto-detect find them."       )
        , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}, "An org admin publishes it."    )
        , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}, "Send it from any chat. The family fills it in and signs, and the stamped PDF comes back to the chat."                    )
      )
      , _react2.default.createElement('div', { className: "forms-empty--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
        , _react2.default.createElement(_Form.Button, { onClick: onUpload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}, _react2.default.createElement(_icons.UploadIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 106}} ), " Upload a file"   )
        , _react2.default.createElement(_Form.Button, { isOutlined: true, onClick: onScan, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}, _react2.default.createElement(_icons.CameraIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 107}} ), " Scan with your phone"    )
      )
    )
  )
); exports.LibraryEmpty = LibraryEmpty








/* Screens 13 and 15: the org's forms as page cards. */
const Library = ({ forms, firstPages, isAdmin, onOpen }) => {
  const me = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const waiting = isAdmin ? forms.filter(f => exports.statusOf.call(void 0, f) === 'waiting' && f.PublishRequestedTo === me) : []
  return (
    _react2.default.createElement('div', { className: "forms-library", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
      ,  waiting.length > 0 && _react2.default.createElement(AdminBanner, { count: waiting.length, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}} ) 
      , _react2.default.createElement('div', { className: "forms-grid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}
        ,  forms.map(f => (
          _react2.default.createElement(FormCard, {
            key: f.FormKey,
            form: f,
            firstPage: firstPages[f.FirstPageFileKey],
            isMine: isAdmin && f.PublishRequestedTo === me,
            onOpen: onOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
          )
        ))
      )
    )
  )
}

exports. default = Library
